[
  {
    "code": "CH-AG",
    "name": "Aargau"
  },
  {
    "code": "CH-AR",
    "name": "Appenzell Ausserrhoden"
  },
  {
    "code": "CH-AI",
    "name": "Appenzell Innerrhoden"
  },
  {
    "code": "CH-BL",
    "name": "Basel-Landschaft"
  },
  {
    "code": "CH-BS",
    "name": "Basel-Stadt"
  },
  {
    "code": "CH-BE",
    "name": "Bern"
  },
  {
    "code": "CH-FR",
    "name": "Freiburg"
  },
  {
    "code": "CH-GE",
    "name": "Genève"
  },
  {
    "code": "CH-GL",
    "name": "Glarus"
  },
  {
    "code": "CH-GR",
    "name": "Graubünden"
  },
  {
    "code": "CH-JU",
    "name": "Jura"
  },
  {
    "code": "CH-LU",
    "name": "Luzern"
  },
  {
    "code": "CH-NE",
    "name": "Neuchâtel"
  },
  {
    "code": "CH-NW",
    "name": "Nidwalden"
  },
  {
    "code": "CH-OW",
    "name": "Obwalden"
  },
  {
    "code": "CH-SG",
    "name": "Sankt Gallen"
  },
  {
    "code": "CH-SH",
    "name": "Schaffhausen"
  },
  {
    "code": "CH-SZ",
    "name": "Schwyz"
  },
  {
    "code": "CH-SO",
    "name": "Solothurn"
  },
  {
    "code": "CH-TG",
    "name": "Thurgau"
  },
  {
    "code": "CH-TI",
    "name": "Ticino"
  },
  {
    "code": "CH-UR",
    "name": "Uri"
  },
  {
    "code": "CH-VD",
    "name": "Vaud"
  },
  {
    "code": "CH-VS",
    "name": "Wallis"
  },
  {
    "code": "CH-ZG",
    "name": "Zug"
  },
  {
    "code": "CH-ZH",
    "name": "Zürich"
  }
]